import { SelectInterface } from '../interfaces/select.interface';
import { SelectSelectModel } from './select-select.model';
import { SelectOptionsModel } from './select-options.model';
import { FormConfigBase } from './abstract/form-config-base.class';
import { BtnTooltipModel } from './btn.tooltip.model';
import { SelectSelectInterface } from '../interfaces/select-select.interface';
import { SelectOptionsInterface } from '../interfaces/select-options.interface';
import { BtnTooltipInterface } from '../interfaces/btn-tooltip.interface';

export class SelectModel extends FormConfigBase {
  select?: SelectSelectInterface;
  options?: SelectOptionsInterface;
  tooltip?: BtnTooltipInterface;

  constructor( obj: SelectInterface ) {
    super( obj );

    this.select = obj && obj.select ? new SelectSelectModel( obj.select ) : null;
    this.options = obj && obj.options ? new SelectOptionsModel( obj.options ) : null;
    this.tooltip = obj && obj.tooltip ? new BtnTooltipModel( obj.tooltip ) : null;
  }

}
